import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

export default function BrandLogoCarousel() {    
    const brandLogos = [
        { name: "Toshiba", url: "https://hncnzwww.blob.core.windows.net/www/img/sector/design-architecture-toshiba-logo.png" },
        { name: "Rinnairl", url: "https://hncnzwww.blob.core.windows.net/www/img/sector/design-architecture-rinnai-logo.png" },
        { name: "Real Flame", url: "https://hncnzwww.blob.core.windows.net/www/img/products/heating-cooling-real-flame-logo-carousel.png" },
        { name: "Panasonic", url: "https://hncnzwww.blob.core.windows.net/www/img/sector/design-architecture-panasonic-logo.png" },
        { name: "Nobo", url: "https://hncnzwww.blob.core.windows.net/www/img/products/heating-cooling-nobo-logo-carousel.png" },
        { name: "Noirot", url: "https://hncnzwww.blob.core.windows.net/www/img/products/heating-cooling-noirot-logo-carousel.png" },
        { name: "Mitsubishi", url: "https://hncnzwww.blob.core.windows.net/www/img/sector/design-architecture-mitsubishi-electric-logo.png" },
        { name: "Masport", url: "https://cdn01.harveynormancommercial.nz/www/img/products/heating-cooling-masport-logo-carousel.png" },
        { name: "Kelvinator", url: "https://cdn01.harveynormancommercial.nz/www/img/products/heating-cooling-kelvinator-logo-carousel.png" },
        { name: "HeatStrip", url: "https://hncnzwww.blob.core.windows.net/www/img/products/heating-cooling-heatstrip-logo-carousel.png" },
        { name: "Casmate", url: "https://hncnzwww.blob.core.windows.net/www/img/products/heating-cooling-gasmate-logo-carousel.png" },
        { name: "Fujitsu", url: "https://hncnzwww.blob.core.windows.net/www/img/sector/design-architecture-fujitsu-logo.png" },
        { name: "dyson", url: "https://hncnzwww.blob.core.windows.net/www/img/sector/design-architecture-dyson-logo.png" },
        { name: "Dimplex", url: "https://cdn01.harveynormancommercial.nz/www/img/products/heating-cooling-dimplex-logo-carousel.png" },
    ];
    // Embla autoplay plugin instance
    const autoplay = Autoplay({ delay: 2000, stopOnInteraction: false });

    return (
        <div className="w-full py-16 relative overflow-hidden bg-white">          
            <div className="max-w-12xl mx-auto px-4 ">
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-gray-900 mb-10 md:mb-16 lg:mb-24">Our Trusted Brands</h2>
                <Carousel
                    opts={{ align: "start", loop: true, slidesToScroll: 1 }}
                    plugins={[autoplay]}
                >
                    <CarouselContent>
                        {brandLogos.map((logo, idx) => (
                            <CarouselItem
                                key={idx}
                                className="flex flex-col items-center justify-center px-6 basis-1/2 md:basis-1/3 lg:basis-1/5"
                            >
                                <img
                                    src={logo.url}
                                    alt={logo.name + ' logo'}
                                    className="h-7 w-auto md:h-10 lg:h-12 object-contain transition duration-300   m-0"
                                    loading="lazy"
                                />
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <CarouselPrevious />
                    <CarouselNext />
                </Carousel>
            </div>
        </div>
    );
}